import React from "react"
import * as s from "./divider.module.less"
export const Divider = () => {
	return (
		<hr className={ s.divider }/>
	)
}
